import { GAMIFICATION_ROUTES } from "../gamification/gamificationRoutes";
import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import MyWalletSidebar from "../MyWalletSidebar";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../questionBank/QuestionBankList.css";
import HeaderProfileSection from "../HeaderProfileSection";
import GroupBattleCard from "./GroupBattleCard";
import ResultBottomNavigation from "./ResultBottomNavigation";
import { useSidebarData } from "../../hooks/useSidebarData";
import { getStoredUser } from "../../utils/authStorage";
import {
  buildGamificationFlowState,
  getStoredGamificationFlowState,
} from "../gamification/gamificationFlowState";
import "./GroupOpponentWaiting.css";
import "./GamificationBattleResult.css";

const BattleResult = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: sidebarData } = useSidebarData();
  const flowState = useMemo(
    () =>
      buildGamificationFlowState(
        location.state,
        getStoredGamificationFlowState(),
      ),
    [location.state],
  );
  const result = flowState?.result_snapshot || {};
  const profile = sidebarData?.user_data || getStoredUser() || {};
  const currentUserId = Number(profile?.user_id || profile?.id || 0);
  const players =
    Array.isArray(result?.score_list) && result.score_list.length
      ? result.score_list
      : Array.isArray(flowState?.liveScore?.score_list) &&
          flowState.liveScore.score_list.length
        ? flowState.liveScore.score_list
        : flowState?.users_list || [];
  const resultLabel = String(
    result?.result_key ||
      result?.result_status ||
      result?.result_title ||
      result?.title ||
      "",
  ).toLowerCase();
  const winnerValue = String(result?.is_winner ?? "")
    .trim()
    .toLowerCase();
  const hasWon =
    ["true", "1", "y", "yes", "win", "winner", "victory"].includes(
      winnerValue,
    ) || /victory|\bwon\b|\bwin\b/.test(resultLabel);
  const hasDraw =
    !hasWon &&
    (winnerValue === "draw" ||
      winnerValue === "tie" ||
      resultLabel.includes("draw") ||
      resultLabel.includes("tie"));
  const hasLost =
    !hasWon &&
    !hasDraw &&
    (["false", "0", "n", "no", "lose", "loss", "defeat"].includes(
      winnerValue,
    ) ||
      /defeat|\blost\b|\bloss\b|\blose\b/.test(resultLabel));
  const title =
    result?.result_title ||
    result?.title ||
    (hasWon
      ? "Victory"
      : hasLost
        ? "Defeat"
        : hasDraw
          ? "Draw"
          : "Battle Complete");
  const outcomeIcon = hasWon
    ? { emoji: "🥳", label: "Victory", type: "victory" }
    : hasLost
      ? { emoji: "😔", label: "Defeat", type: "defeat" }
      : hasDraw
        ? { emoji: "🤝", label: "Draw", type: "draw" }
        : { emoji: "🙂", label: "Battle complete", type: "complete" };
  const coins =
    result?.coins_won ?? result?.coins_earned ?? result?.coin_change;
  const battleName =
    flowState?.selectedBattle?.battles_name ||
    flowState?.selectedBattle?.battle_name ||
    "Battle";
  const roomState = {
    ...flowState,
    battles_id: Number(
      flowState?.battles_id || flowState?.selectedBattle?.battles_id || 0,
    ),
    battle_room_id: Number(flowState?.battle_room_id || 0),
  };
  const navigateTo = (pathname) => navigate(pathname, { state: roomState });
  const shareScore = async () => {
    const shareText = `I completed ${battleName}${result?.rank ? ` at rank ${result.rank}` : ""}!`;
    try {
      if (navigator.share)
        await navigator.share({ title: "Battle Result", text: shareText });
      else if (navigator.clipboard?.writeText)
        await navigator.clipboard.writeText(shareText);
    } catch (_error) {
      // The user can dismiss the native share sheet.
    }
  };

  return (
    <>
      {/* Page Height Setup */}
      <style>
        {`      
.homeDashboard-wrapper .page-content {
    padding-right: 0;
}
.sectionWrapper{
   width: 100%;
   justify-content: space-between;
   gap: 20px;
   display: grid;
    grid-template-columns: minmax(0, 1fr) 320px;
}
.battle-result-layout .gamification-result-page .instruction-main {
    width: 100%;
}  
.resultContent {
    background: #fff;
    border: 1px solid #ededed;
    border-radius: 18px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.navigationFixe {
    background: #fff;
    border: 1px solid #ededed;
    border-radius: 18px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    padding: 35px 40px 30px;
}
.result-bottom-nav {
    display: block;
    text-align: center;
}
.result-nav-item {
    display: block;
    text-align: center;
    width: 100%;
    margin-bottom: 25px;
}
.result-nav-icon {
  margin: auto;
}
.rapid-Card{
  padding:20px 0 10px;
}
.gamification-result-page .opponentItem {
    width: 130px;
}
@media (min-width: 992px) and (max-width: 1400px){
.sectionWrapper{
   grid-template-columns: minmax(0, 1fr) 290px;
}
}
@media (min-width: 768px) and (max-width: 991px){
.sectionWrapper{
   grid-template-columns: minmax(0, 1fr) 250px;
}
}
@media (max-width: 767px){
   .sectionWrapper {
    display: block;
}
.resultContent {
     margin-bottom: 20px;
}
}
`}
      </style>
      <HomeDashboardLayout showHeader={false} variant="battle-result-layout">
        <div className="qbl-page qbankList-page page-padding start-gamification gamification-result-page">
          <div className="hideProfile-page">
            <div className="categories-page-header mb-0">
              <button
                type="button"
                className="categories-back-button"
                aria-label="Back to battles"
                onClick={() => navigateTo(GAMIFICATION_ROUTES.start)}
              >
                <i className="bi bi-chevron-left" />
              </button>
              <span className="categories-page-title" aria-hidden="true" />
              <HeaderProfileSection />
            </div>
          </div>
          <div className="rapid-Card">
            <h1 className="qb-title">
              {battleName} <span>Result</span>
            </h1>
            <p className="game-description">Complete, Learn & improve Daily</p>
          </div>
          <div className="start-quiz qbl-main instruction-main">
            <div className="sectionWrapper">
              <div className="resultContent">
                <div
                  className={`defeat-result${hasWon ? " defeat-result--victory" : hasDraw ? " defeat-result--draw" : ""}`}
                >
                  <div
                    className={`defeat-result__emoji defeat-result__emoji--${outcomeIcon.type}`}
                    role="img"
                    aria-label={outcomeIcon.label}
                  >
                    {outcomeIcon.emoji}
                  </div>
                  <h2 className="defeat-result__title">{title}</h2>
                  {coins !== undefined && coins !== null && (
                    <div className="defeat-result__coins">Coins: {coins}</div>
                  )}
                  <div className="defeat-result__message">
                    {result?.result_message ||
                      result?.message ||
                      "Your battle is complete."}
                  </div>
                  {result?.rank && (
                    <p className="defeat-result__subtitle">
                      Rank: {result.rank}
                    </p>
                  )}
                  <div className="defeat-result__divider" />
                </div>
                <GroupBattleCard
                  players={players}
                  currentUserId={currentUserId}
                />
              </div>

              <div className="navigationFixe">
                <ResultBottomNavigation
                  onReviewAnswers={() =>
                    navigateTo(GAMIFICATION_ROUTES.answerSheet)
                  }
                  onShareScore={shareScore}
                  onLeaderboard={() =>
                    navigateTo(GAMIFICATION_ROUTES.battleLeaderboard)
                  }
                  onHome={() => navigateTo(GAMIFICATION_ROUTES.start)}
                />
              </div>
            </div>
          </div>
        </div>
        {/* <MyWalletSidebar withTopOffset={false} /> */}
      </HomeDashboardLayout>
    </>
  );
};

export default BattleResult;
